import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Atelier theme toggle — Sun/Moon icon button.
 * Intentionally small + subtle; uses coral accent on hover.
 */
const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? '切換到淺色主題' : '切換到深色主題'}
      title={isDark ? '切換到淺色主題 (Light)' : '切換到深色主題 (Dark)'}
      data-testid="theme-toggle-btn"
      className={[
        'relative inline-flex items-center justify-center',
        'h-9 w-9 rounded-full',
        'border border-atelier-line hover:border-atelier-coral/60',
        'bg-atelier-surface hover:bg-atelier-surface2',
        'text-atelier-mute hover:text-atelier-coral',
        'transition-all duration-300 ease-out',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atelier-coral/40',
        className,
      ].join(' ')}
    >
      <Sun
        className={[
          'absolute h-4 w-4 transition-all duration-400 ease-out',
          isDark ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100',
        ].join(' ')}
        strokeWidth={1.6}
      />
      <Moon
        className={[
          'absolute h-4 w-4 transition-all duration-400 ease-out',
          isDark ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0',
        ].join(' ')}
        strokeWidth={1.6}
      />
    </button>
  );
};

export default ThemeToggle;
